
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeRisorseDialog extends Serenity.EntityDialog<AssetEsperienzeRisorseRow, any> {
        protected getFormKey() { return AssetEsperienzeRisorseForm.formKey; }
        protected getIdProperty() { return AssetEsperienzeRisorseRow.idProperty; }
        protected getLocalTextPrefix() { return AssetEsperienzeRisorseRow.localTextPrefix; }
        protected getService() { return AssetEsperienzeRisorseService.baseUrl; }
        protected getDeletePermission() { return AssetEsperienzeRisorseRow.deletePermission; }
        protected getInsertPermission() { return AssetEsperienzeRisorseRow.insertPermission; }
        protected getUpdatePermission() { return AssetEsperienzeRisorseRow.updatePermission; }

        protected form = new AssetEsperienzeRisorseForm(this.idPrefix);

    }
}